export default class aeAriaLive {
    constructor() {
        Vue.component('ae-aria-live', {
            props: {
                value: String,
                ariaLive: {
                    type: String,
                    default: 'assertive',
                    validator: value => ['assertive', 'polite', 'off'].indexOf(value) !== -1,
                },
            },
            data() {
                return {
                    textToRead: '',
                };
            },

            methods: {
                say(text) {
                    if (text) {
                        //this.textToRead.push(text);
                        this.textToRead = text;
                    }
                },
            },
            mounted() {
                this.say(this.value);
            },

            watch: {
                value: function (valNew, oldVal) {
                    this.say(valNew);
                },
            },
            template: function () {
                var template = `
                    <div>
                    <template>
                        <div class="assistive-text" :aria-live="ariaLive" aria-atomic="true">
                            <slot></slot>
                            <div>{{textToRead}}</div>
                        </div>
                    </template>
                    </div>
                `;
                return template;
            }()
        });
    }
}


// <div>
// <template>
// <div class="assistive-text" :aria-live="ariaLive" aria-relevant="additions">
//     <slot></slot>
//     <div v-for="(text, index) in textToRead" :key="index">{{text}}</div>
// </div>
// </template>
// </div>